import React, { useEffect, useRef, useState } from 'react';
import { Routes as RouterRoutes, Route, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { APP_NAME, AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import ClearStorage from 'auth/ClearStorage';
import { getMethodService, publicGetMethodService } from 'services';
import { PENDINT_APPLY_AGENT_COUNT, PENDINT_DEPOSIT_COUNT, PENDINT_WITHDRAW_COUNT, SETTING_JSON, SETTINGS_API } from 'services/apis';
import { useDispatch, useSelector } from 'react-redux';
import { setsettings } from 'store/slices/settingsSlice';
import Maintenance from 'utils/Maintenance';
import Cookies from 'js-cookie';
import { decodeAuth, encodeAuth, LogoutHandle, playNotiSong } from 'utils/Helper';
import { setsettingsAgent } from 'store/slices/settingAgentSlice';
import ActiveUsers from 'views/app-views/ActiveUsers';
import GetEnv from 'views/app-views/GetEnv';
import {io} from "socket.io-client";
import { message } from 'antd';
import { depositCountHandler, withdrawCountHandler } from 'store/slices/paymentPendingCountSlice';
import { applyAgentPendingHandler } from 'store/slices/applyAgentPendingSlice';

const Routes = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [intervalStatus,setIntervalStatus] = useState(true);
	const [messageApi, contextHolder] = message.useMessage();
	const intervalRef = useRef(null);
	const getAuth = Cookies.get("vb\C#^*gW589");
	let userAuth = getAuth && decodeAuth(getAuth);
	const {paymentPendingCount} = useSelector((state) => state);
	const {applyAgentPendingCount} = useSelector((state) => state);

	const alertMessage = (status, msg) => {
		messageApi.open({
		  type: status,
		  content: msg,
		});
	};

	const fetchPendingDepositCount = async () => {
		let res = await getMethodService(PENDINT_DEPOSIT_COUNT());
		if(res){
			if(res === "Unauthenticated"){
				return LogoutHandle(navigate);
			};
			if(res.status === "success" || res.status || res.success){
				dispatch(depositCountHandler(res?.data?.pending_deposit));
			}else{
				alertMessage("error",res);
			};
		};
	};

	const fetchPendingWithdrawCount = async () => {
		let res = await getMethodService(PENDINT_WITHDRAW_COUNT());
		if(res){
			if(res === "Unauthenticated"){
				return LogoutHandle(navigate);
			};
			if(res.status === "success" || res.status || res.success){
				dispatch(withdrawCountHandler(res?.data?.pending_withdrawal));
			}else{
				alertMessage("error",res);
			};
		};
	};

	const fetchPendingApplyAgentCount = async () => {
		let res = await getMethodService(PENDINT_APPLY_AGENT_COUNT());
		if(res){
			if(res === "Unauthenticated"){
				return LogoutHandle(navigate);
			};
			if(res.status === "success" || res.status || res.success){
				dispatch(applyAgentPendingHandler(res?.data?.pending_agent_request));
			}else{
				alertMessage("error",res);
			};
		};
	};

	useEffect(()=>{
		if(pathname === '/admin/login' || pathname === '/agent/login'){
			return;
		}else{
			if(APP_NAME !== "sportsxzone"){
				fetchPendingWithdrawCount();
				fetchPendingDepositCount();
				fetchPendingApplyAgentCount();
			};
		};
	},[pathname]);

	useEffect(()=>{
		if(APP_NAME !== "sportsxzone"){
			let url= process.env.REACT_APP_MAIN_DOMAIN;
			const socket = io(url,{
				transports: ["websocket"],
				path: '/api/main/socket',
			});
			socket.connect();
			socket.on("store-deposit", (data) => {
				if(userAuth?.user?.role_name === 'admin'){
					playNotiSong();
				};
				dispatch(depositCountHandler(paymentPendingCount?.depositCount + 1));
			});      
			socket.on("store-withdrawal", (data) => {
				if(userAuth?.user?.role_name === 'admin'){
					playNotiSong();
				};
				dispatch(withdrawCountHandler(paymentPendingCount?.withdrawCount + 1));
			});  
			socket.on("store-agent-requests", (data) => {
				if(userAuth?.user?.role_name === 'admin'){
					playNotiSong();
				};
				dispatch(applyAgentPendingHandler(applyAgentPendingCount?.count + 1));
			});      
			return () => {
				socket.disconnect();
			};
		};
    },[]);

	// console.log(paymentPendingCount)

	const fetchSettingJson = async () => {
		const res = await publicGetMethodService(SETTING_JSON);
        if(res){
            let obj = {
                status: res?.is_active_dashboard,
                remark: res?.disable_reason,
                announancement: null,
            };
			setIntervalStatus(obj?.status);
            dispatch(setsettings(obj));
            dispatch(setsettingsAgent(null));
            if(!obj?.status){
				Cookies.remove("vb\C#^*gW589");
                return navigate("/maintenance");
            }else{
				getSettings();
			};
        };
    };

	const getSettings = async () => {
		dispatch(setsettings(null));
		let res = await getMethodService(SETTINGS_API());
		if(res){
			if(res === "Unauthenticated"){
				return LogoutHandle(navigate);
			};
			if(res.status === "success" || res.status || res.success){
				if(res?.data?.id){
					let obj = {
						status: res?.data?.is_active_dashboard,
						remark: res?.data?.disable_reason,
						dashboard_announancement: res?.data?.dashboard_announancement,
						announancement: null,
						is_active_slot_report_admin: res?.data?.is_active_slot_report_admin,
						is_active_slot_report_agent: res?.data?.is_active_slot_report_agent,
					};
					setIntervalStatus(obj?.status);
					dispatch(setsettingsAgent(obj));
					if(!obj?.status){
						if(userAuth){
							if(userAuth?.user?.role_name !== 'admin'){
								return navigate("/maintenance");
							};
						};
					};
				};
			};
		};
	};

	useEffect(()=>{
        if(!intervalStatus){
            intervalRef.current = setInterval(() => {
                fetchSettingJson();
            }, 1000 * 10);
        }else{
            clearInterval(intervalRef.current);
        };
    },[intervalStatus]);

	useEffect(() => {
		window.scrollTo(0, 0);
		if(pathname !== '/active-user'){
			fetchSettingJson();
		};
	}, [pathname]);

	return (
		<>
			{contextHolder}
			<RouterRoutes>
				<Route path="/active-user" element={<ActiveUsers />} />
				<Route path="/maintenance" element={<Maintenance />} />
				<Route path="/get-env" element={<GetEnv />} />
				<Route path="/" element={<ProtectedRoute />}>
					<Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
					{protectedRoutes.map((route, index) => {
						return (
							<Route 
								key={route.key + index} 
								path={route.path}
								element={
									<AppRoute
										routeKey={route.key} 
										component={route.component}
										{...route.meta} 
									/>
								}
							/>
						)
					})}
					<Route path="/clear" element={<ClearStorage />} />
					<Route path="*" element={<Navigate to="/" replace />} />
				</Route>
				<Route path="/" element={<PublicRoute />}>
					{publicRoutes.map(route => {
						return (
							<Route 
								key={route.path} 
								path={route.path}
								element={
									<AppRoute
										routeKey={route.key} 
										component={route.component}
										{...route.meta} 
									/>
								}
							/ >
						)
					})}
				</Route>
			</RouterRoutes>
		</>
	)
}

export default Routes